import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import React from "react";
import IconButton from "@mui/material/IconButton";
import { useDeleteTeamUserByIdMutation } from "entitites/teams/api/teamsApi";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";

export const TeamCard = ({ user, teamId }: { user: any; teamId: string }) => {
  const [deleteUsr] = useDeleteTeamUserByIdMutation();
  const { data: roles } = useGetMyRolesQuery();
  return (
    <Box
      borderRadius="4px"
      p={1}
      bgcolor="#E7E9F1"
      width={282}
      height={166}
      display="flex"
      flexDirection="column"
      position="relative"
    >
      <Typography>
        <strong>{user.fio.split(" ")[0]}</strong> <br />{" "}
        {user.fio.split(" ")[1]} {user.fio.split(" ")[2]}{" "}
        {user.fio.split(" ")[3]} {user.fio.split(" ")[4]}
      </Typography>
      <Box
        bgcolor="white"
        textAlign="center"
        height={77}
        borderRadius="4px"
        mt="auto"
        width="262px"
        alignSelf="center"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {user.profInfo.position.name}
      </Box>
      {Boolean(roles?.includes("staffdesk-admin")) && (
        <IconButton
          onClick={() => deleteUsr({ teamId, id: user.id })}
          size="small"
          sx={{ position: "absolute", right: 0, top: 0 }}
        >
          <DeleteIcon htmlColor="#9696E2" fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
